"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authMutations = exports.authMutationsKeys = void 0;
const auth_api_1 = require("./auth.api");
exports.authMutationsKeys = {
    all: () => ['auth'],
    loginGuest: () => [...exports.authMutationsKeys.all(), 'loginGuest'],
    loginCheckout: () => [...exports.authMutationsKeys.all(), 'loginCheckout'],
};
const authMutations = (apiOptions) => ({
    loginGuestMutation: (options = {}) => (Object.assign(Object.assign({}, options), { mutationKey: exports.authMutationsKeys.loginGuest(), mutationFn: (params) => (0, auth_api_1.loginGuest)(apiOptions, params) })),
    loginCheckoutMutation: (options = {}) => (Object.assign(Object.assign({}, options), { mutationKey: exports.authMutationsKeys.loginCheckout(), mutationFn: (params) => (0, auth_api_1.loginCheckout)(apiOptions, params) })),
});
exports.authMutations = authMutations;
//# sourceMappingURL=auth.mutations.js.map